import { render } from "./IconSelector.vue?vue&type=template&id=13073f2d"
import script from "./IconSelector.vue?vue&type=script&lang=js"
export * from "./IconSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__